
//Import
import React from 'react'
import styled from 'styled-components'
import styles from './GroupProgress_styles'

// Componente base
const GroupProgress_base = ({...props}) => {
    return (
        <div {...props}>
            {props.children}
        </div>
    )
}
const GroupProgress = styled(GroupProgress_base)`${ styles }`
export default GroupProgress
